import { EDemandRequestStatus } from '../../../constants/demandRequestStatus';

export const DEMAND_MESSAGES = {
  [EDemandRequestStatus.RealtorForm]:
    'Оставьте заявку и выберите риелтора — специалист проведёт сделку быстро и безопасно',
  [EDemandRequestStatus.RequestSent]:
    'Заявка отправлена! В ближайшее время с вами свяжутся риелторы, работающие с Циан',
  [EDemandRequestStatus.SendRequest]:
    'Оставьте заявку и выберите риелтора — специалист проведёт сделку быстро и безопасно',
  error: 'Ошибка отправки заявки! Пожалуйста, попробуйте отправить заявку еще раз',
};
